module.exports = __webpack_public_path__ + "media/images/writer/user_extension_notification_mailer/partner_program-57f1bdcaf0cf40b77cf95f6c800fd24a.png";